export const ORDER_VARIANT_ATTRIBUTES_STATE = 'order.variant.attributes.state-' // + orderId

export const AUTH_LOGOUT_STATE = 'auth.logout'

export const EARNINGS_REPORT_STATE = 'earningReport.filters'

export const ORDERS_DEFAULT_SORT_STATE = 'orders.defaultSort'

export const SHOP_FLOOR_ACTIVITY_LOG_STATE = 'shopFloorActivityLog.state'

export {
  clearState,
  getStoredState,
  storeState
} from '@mono/packages/utils/localStorage'
